export default __webpack_public_path__ + "static/media/ommuseBackground.f35be5bc.png";